/**
 * Will replace all but the kept "numCharsToKeepFromTheEnd" chars with the "replacingSymbol" char from the "input" string.
 * If "threshold" is positive, it will correspond to the number of chars from the beginning to replace.
 * If "threshold" is negative, it will correspond to the number of chars we want to keep at the end.
 * @param input
 * @param replacingSymbol
 * @param threshold
 */
export const hideAndReplaceString = (input: string, replacingSymbol: string, threshold: number): string => {
  let replaceExp = new RegExp(`^(.*)(.{${Math.max(input.length - threshold, 0)}})(.*)$`)
  if (threshold === 0) {
    return input
  }
  if (threshold < 0) {
    replaceExp = new RegExp(`^(.{${Math.max(input.length - Math.abs(threshold), 0)}})(.*)$`)
  }
  return input.replace(replaceExp, (_match, hidden, visible) => replacingSymbol.repeat(hidden.length) + visible)
}
